import { apiCall, ApiResponse } from "./apiClient";
import { FormTemplateDto } from "../models/form/formTemplate";

export const getFormTemplates = (
    signal?: AbortSignal
): Promise<ApiResponse<FormTemplateDto[]>> => {
    return apiCall<FormTemplateDto[], { activeOnly: boolean }>(
        "FormTemplates",
        "GET",
        { activeOnly: true },
        signal
    );
};

export const getFormTemplate = (
    id: string,
    signal?: AbortSignal
): Promise<ApiResponse<FormTemplateDto>> => {
    return apiCall<FormTemplateDto>(`FormTemplates/${id}`, "GET", null, signal);
};
